import React from "react";
import styled, { keyframes } from "styled-components";

const StreakIndicator = ({ streak }) => {
  if (!streak || streak < 3) return null;

  return (
    <Container>
      <Icon>🔥</Icon>
      <Count>x{streak}</Count>
    </Container>
  );
};

export default StreakIndicator;

const popIn = keyframes`
  0% {
    transform: scale(0.6);
    opacity: 0;
  }
  60% {
    transform: scale(1.15);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 14px;
  border-radius: 999px;
  background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);
  border: 2px solid #f97316;
  color: #c2410c;
  font-weight: 800;
  box-shadow: 0 4px 14px rgba(249, 115, 22, 0.35);
  animation: ${popIn} 0.35s ease-out both;
  margin-bottom: 12px;
`;

const Icon = styled.span`
  font-size: 20px;
  line-height: 1;
`;

const Count = styled.span`
  font-size: 18px;
  line-height: 1;
`;
